<template>
    <div class="offcanvas-body">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'OffcanvasBody'
    }
</script>
